import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import Toolbox from "./Toolbox";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { TrackNowButton } from "../ui/TrackNowButton";
import CustomDialog from "../common/CustomDialog";
import ClientFilingTrackerTable from "./ClientFilingTrackerTable";
import ClientLookup from "../customer/ClientLookup";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import CustomerContext from "../../context/customer/CustomerContext";
import ClientFilingTrackerComments from "./ClientFilingTrackerComments";
import axios from "axios";
import ClientFilingTrackerAttachment from "./ClientFilingTrackerAttachments";
import ClientFilingTrackerHistory from "./ClientFilingTrackerHistory";
import ClientFilingTrackerDocuments from "./ClientFilingTrackerDocuments";
import useDialog from "../common/UseDialog";
import AuthContext from "../../context/auth/AuthContext";
import { Typography, Dialog, LinearProgress, CircularProgress, Box } from "@mui/material";
import ClientFilingBulkStatusUpdate from "./ClientFilingBulkStatusUpdate";
import ClientFilingConsolidatedUpdate from "./ClientFilingConsolidatedUpdate";
import states from "../../data/StateLookup.json";
import Stack from "@mui/material/Stack";
import { useCommonDetailsContext } from '../../context/Common/common';
import { tokens } from "../../theme/tokens";
import { NoticeIllustration } from "../common/DialogIllustrations";
import { MultiSelect } from "primereact/multiselect";
import usePermission from "../../usePermission";
import * as xlsx from "xlsx";
import { saveAs } from "file-saver";
import CustomerOrgStructure from "../customer/CustomerOrgStructure";

// import ClientSpecificFilingConsolidateView from "./ClientSpecificFilingConsolidateView";
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function ClientFilingTrackerList({ onAddClientSpecificFilingClick }) {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [showBulkStatusDrawer, setShowBulkStatusDrawer] = useState(false);
  const [bulkUpdateRecords, setBulkUpdateRecords] = useState([]);
  const [commonStaffs, setCommonStaffs] = useState([]);
  let { clientId } = useParams();
  const [selectedClientId, setSelectedClientId] = useState(clientId);
  // const [selectedClientFiling, setSelectedClientFiling] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [radioMessage, setRadioMessage] = useState(
    "Which Defered Filing you want to open"
  );
  const [radioVal, setRadioVal] = React.useState("tracknow");
  const [showAlert, setShowAlert] = useState(false);
  const [selectedFiling, setSelectedFiling] = useState([]);
  const [underDetailedViewProps, setUnderDetailedViewProps] = useState(false);
  const [tablValue, setTablValue] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [clientFilingData, setClientFilingData] = useState(null);
  const [showRadio, setShowRadio] = useState(false);
  const [showRadio1, setShowRadio1] = useState(false);
  const [showRadioEdit, setShowRadioEdit] = useState(false);
  const [radioMessage1, setRadioMessage1] = useState(
    "Which record type do you want to create?"
  );
  const [radioVal1, setRadioVal1] = React.useState("tracknow");
  const [showComments, setShowComments] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [showConsolidated, setShowConsolidated] = useState(false);
  const [showClientSpecificConsolidated, setShowClientSpecificConsolidated] =
    useState(false);
  const [documents, setDocuments] = React.useState([]);
  const [consolidatedRecords, setConsolidatedRecords] = React.useState([]);
  const [affectedCompanyLists, setAffectedCompanyLists] = React.useState([]);
  const [affectedCompanyListsDropdown, setAffectedCompanyListsDropdown] =
    React.useState([]);

  const [selectedAffectedCompanies, setSelectedAffectedCompanies] =
    React.useState([]);
  const [isCompanySelectOpen, setIsCompanySelectOpen] = useState(false);
  const [isCompanySelectEditOpen, setIsCompanySelectEditOpen] = useState(false);
  const [customerNames, setCustomerNames] = React.useState([]);
  const [selectedAffectedCompaniesEdit, setSelectedAffectedCompaniesEdit] =
    React.useState([]);
  const [
    selectedAffectedCompaniesEditInitial,
    setSelectedAffectedCompaniesEditInitial,
  ] = React.useState([]);
  const [
    selectedAffectedCompaniesEditInitialNames,
    setSelectedAffectedCompaniesEditInitialNames,
  ] = React.useState([]);
  const [consolidatedClientFilingList, setConsolidatedClientFilingList] =
    React.useState([]);
  const [consolidatedStatus, setConsolidatedRecordsStatus] = React.useState([]);
  const [staffList, setStaffList] = React.useState([]);
  const [detailedViewVal, setDetailedViewVal] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [clientActivityHistory, setClientActivityHistory] = React.useState([]);
  const [commentActivityHistory, setCommentActivityHistory] = React.useState(
    []
  );
  const [isTnistoryLoading, setIsTnHistoryLoading] = useState(true);
  const [isCfHistoryLoading, setIsCfHistoryLoading] = useState(true);
  const [isCommentsHistoryLoading, setIsCommentsHistoryLoading] =
    useState(true);
  const [downloadData, setDownloadData] = React.useState([]);
  const [downloadDataHistory, setDownloadDataHistory] = React.useState([]);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadStatusMsg, setDownloadStatusMsg] = useState("");
  const [showDownloadProgress, setShowDownloadProgress] = useState(false);
  const [comments, setComments] = React.useState([]);
  const [attachments, setAttachments] = React.useState([]);
  const [refreshList, setRefreshList] = React.useState(false);
  const [clearSelectedRecords, setClearSelectedRecords] = React.useState(false)
  const [refreshTable, setRefreshTable] = useState(false);
  const [isTrackNowAccess, setIsTrackNowAccess] = useState(false);
  const [isPostAwardAccess, setIsPostAwardAccess] = useState(false);
  const [sortRecord, setSortRecord] = useState("Upcoming Due Dates");
  const [keepSelectedRecords, setKeepSelectedRecords] = useState([]);
  const [keepPageDetails, setKeepPageDetails] = useState(false);
  const [isDeleteClientFiling, setIsDeleteClientFiling] = useState(false);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { setSnackBarData, snackBarData, validateParentData, fetchClientBranding, setClientScopedBranding } = useCommonDetailsContext();
  const { getClientFilingTrackerComments, getClientFilingTrackerAttachments, fetchConfigurations } =
    clientFilingMasterContext;
  const [organizationalStructure, setOrganizationalStructure] = React.useState({});
  const [showOrgStructure, setShowOrgStructure] = useState(false);

  const customerContext = useContext(CustomerContext);
  const { getCustomers, customers, selectedCustomer, setCurrentCustomer } = customerContext;

  useEffect(() => {
    const targetId = selectedClientId || clientId;

    if (!validateParentData?.isSingleParent && targetId && fetchClientBranding) {
      const customerList = customers || [];
      const selected = customerList.find((c) => String(c.customerId) === String(targetId)) || (String(selectedCustomer?.customerId) === String(targetId) ? selectedCustomer : null);
      const customerType = selected?.customerType || selected?.clientType;
      fetchClientBranding(targetId, customerType);
    } else if (!targetId && setClientScopedBranding) {
      setClientScopedBranding(null);
    }
  }, [selectedClientId, clientId, validateParentData?.isSingleParent, fetchClientBranding, setClientScopedBranding, customers, selectedCustomer]);

  const filingMasterContext = useContext(FilingMasterContext);
  const {
    setCurrentFilingMaster,
    deleteDraftFilingMaster,
    createFilingMasterWorkflow,
  } = filingMasterContext;

  const authContext = useContext(AuthContext);
  const { roleType, authUser } = authContext;


  const handleRefreshTable = () => {
    // console.log("handleRefreshTable")
    setRefreshTable(true);
  };
  const handleRefreshTableReturn = () => {
    setRefreshTable(false);
  };

  const refreshSelectedRecord = () => {
    setKeepSelectedRecords(selectedFiling);
    setSelectedFiling([]);
    handleRefreshTable();
  };

  const displayFilter = () => {
    setShowFilter(() => true);
  };

  const closeStatusBulkUpdateDrawer = () => {
    setBulkUpdateRecords([]);
    setShowBulkStatusDrawer(() => false);
  };

  const displayAddClientFiling = () => {
    // console.log("displayAddClientFiling selectedCustomer", selectedCustomer);
    if (selectedClientId) {
      if (
        (Number(selectedCustomer?.postAwardLicenseId) === 0 ||
          selectedCustomer?.postAwardLicenseId === null ||
          selectedCustomer?.postAwardLicenseId === "") &&
        selectedCustomer?.trackNowLicenseId &&
        Number(selectedCustomer?.trackNowLicenseId) > 0
      ) {
        //If client has only Tracknow subscription
        navigate(`/add-filings/${selectedClientId}`, { state: { clientName: selectedCustomer?.customerName } });
      } else if (
        (Number(selectedCustomer?.trackNowLicenseId) === 0 ||
          selectedCustomer?.trackNowLicenseId === null ||
          selectedCustomer?.trackNowLicenseId === "") &&
        selectedCustomer?.postAwardLicenseId &&
        Number(selectedCustomer?.postAwardLicenseId) > 0
      ) {
        //If client has only Postaward subscription
        navigate(`/add-filing-postaward/${selectedClientId}`, { state: { clientName: selectedCustomer?.customerName } });
      } else if (
        selectedCustomer?.trackNowLicenseId &&
        Number(selectedCustomer?.trackNowLicenseId) > 0 &&
        selectedCustomer?.postAwardLicenseId &&
        Number(selectedCustomer?.postAwardLicenseId) > 0
      ) {
        //If client has both Tracknow and  Postaward subscription
        setShowRadio(true);
      } else {
        setAlertMessage(
          "Client doesn't have either tracknow or postaward subscriptions."
        );
        setShowAlert(true);
      }
    } else {
      setAlertMessage("Please Select a Client Record");
      setShowAlert(true);
    }
  };

  const fetchCustomerList = async () => {
    //  if (getCustomers) {
    let custList;
    if (customers) {
      custList = customers;
    } else {
      custList = await getCustomers();
    }
    //let custList = await getCustomers();
    let client = custList.filter(
      (ele) => ele.customerId === parseInt(selectedClientId)
    )[0];
    setCurrentFilingMaster({
      ...selectedFiling[0],
      customerId: selectedClientId,
      client: client.customerName,
      from: "Add client filing",
    });

    // };
  };

  const editFiling = async () => {
    try {
      if (selectedClientId && selectedFiling && selectedFiling.length !== 0) {
        if (selectedClientId && selectedFiling && selectedFiling.length > 1) {
          setAlertMessage("Please Select single Client specific Filing ");
          setShowAlert(true);
        } else {
          if (!selectedFiling[0].isMasterFiling) {
            let detalis = await trackerTable.current.refreshPage();
            console.log("editFiling detalis", detalis);

            // if (getCustomers) {
            try {
              let custList;
              if (customers) {
                custList = customers;
              } else {
                custList = await getCustomers();
              }
              //  let custList = await getCustomers();
              let client = custList.filter(
                (ele) => ele.customerId === parseInt(selectedClientId)
              )[0];
              // Extract the year from startdate
              const filingPeriodYear = new Date(selectedFiling[0].filingPeriods.startdate).getFullYear();

              setCurrentFilingMaster({
                ...selectedFiling[0],
                juristiction: selectedFiling[0]?.filingJuristiction,
                stateInfo: selectedFiling[0]?.filingStateInfo,
                customerId: selectedClientId,
                client: client.customerName,
                from: "Edit client filing",
                filingPeriodYear: filingPeriodYear
              });
              console.log(
                "editFiling",
                "selectedAffectedCompanies",
                selectedAffectedCompanies,
                selectedAffectedCompaniesEdit
              );
              if (selectedFiling[0]?.recordType === "TrackNow") {
                onAddClientSpecificFilingClick(true);

                navigate("/filing-master", {
                  state: {
                    selectedAffectedCompanies,
                    selectedAffectedCompaniesEdit,
                    customerNames,
                    page: "ClientFilingTracker",
                    filingPeriodYear,
                    from: "/client-filing-tracker-list",
                    mode: "edit",

                  },
                });
              } else {
                onAddClientSpecificFilingClick(true);

                navigate("/postaward-master-form", {
                  state: {
                    selectedAffectedCompanies,
                    selectedAffectedCompaniesEdit,
                    customerNames,
                    page: "ClientFilingTracker",
                    from: "/client-filing-tracker-list",
                    filingPeriodYear
                  },
                });
              }
            } catch (error) { }
          } else {
            setAlertMessage("Please Select a Client specific Filing to edit ");
            setShowAlert(true);
          }
        }
        //}
      } else {
        setAlertMessage("Please Select a Client specific Filing ");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setSelectedAffectedCompanies([]);
      setSelectedAffectedCompaniesEdit([]);
      setCustomerNames([]);
      setSelectedAffectedCompaniesEditInitial([]);
      setSelectedAffectedCompaniesEditInitialNames([]);
    }
  };

  const addMasterFilling = async () => {
    console.log(
      "addMasterFilling",
      "selectedCustomer",
      selectedCustomer,
      "isTrackNowAccess",
      isTrackNowAccess,
      "isPostAwardAccess",
      isPostAwardAccess,
      "roleType",
      roleType,
      affectedCompanyLists
    );
    if (selectedClientId) {
      // if (getCustomers) {
      try {
        // let custList = await getCustomers();
        // let client = custList.filter(
        //   (ele) => ele.customerId === parseInt(selectedClientId)
        // )[0];
        // setCurrentFilingMaster({
        //   customerId: selectedClientId,
        //   client: client.customerName,
        //   from: "Add client filing",
        // });
        const list = await fetchAffectedCompanies();
        if (
          selectedCustomer.trackNowLicenseId > 0 && selectedCustomer.postAwardLicenseId === 0 &&
          !isTrackNowAccess
        ) {
          setAlertMessage("User doesn't have permission to add Post Award Filing");
          setShowAlert(true)
          return;
        }

        if (
          selectedCustomer.postAwardLicenseId > 0 && selectedCustomer.trackNowLicenseId === 0 &&
          !isPostAwardAccess
        ) {
          setAlertMessage("User doesn't have permission to add TrackNow Filing");
          setShowAlert(true)

          return;
        }
        if (
          selectedCustomer &&
          (selectedCustomer.clientType === "SubChild"
            ||
            selectedCustomer?.isOnlyParentFile || (selectedCustomer?.clientType === "Child" && !selectedCustomer?.bothChildAndSubChild))
        ) {
          //if customer is child
          if (
            selectedCustomer.trackNowLicenseId > 0 &&
            selectedCustomer.postAwardLicenseId > 0
          ) {
            console.log("Check 1");

            if (isTrackNowAccess && isPostAwardAccess) {
              setShowRadio1(true);
            } else if (isPostAwardAccess) {

              navigate("/postaward-master-form", {
                state: {
                  selectedAffectedCompanies,
                  customerNames,
                  from: "/client-filing-tracker-list",
                },
              });
              fetchCustomerList();
              onAddClientSpecificFilingClick(true);
            } else {
              navigate("/filing-master", {
                state: {
                  selectedAffectedCompanies,
                  customerNames,
                  from: "/client-filing-tracker-list",
                  mode: "add",
                },
              });
              fetchCustomerList();
              onAddClientSpecificFilingClick(true);

            }
            //if child customer has both subscription
          } else if (
            selectedCustomer.trackNowLicenseId > 0 && isTrackNowAccess &&
            (selectedCustomer.postAwardLicenseId === 0 ||
              selectedCustomer.postAwardLicenseId === null)
          ) {

            //if child customer has only TN subscription
            navigate("/filing-master", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                from: "/client-filing-tracker-list",
                mode: "add",
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          } else {
            //If child customer has PA subscription
            navigate("/postaward-master-form", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                from: "/client-filing-tracker-list",
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          }
        } else {
          //If customer is parent
          setShowRadio1(true);
        }
      } catch (error) {
        //log("error", error);
      } finally {
        setClearSelectedRecords(true)
      }
      //}
    } else {
      setAlertMessage("Please Select a Client Record");
      setShowAlert(true);
    }
  };
  const editMasterFilling = async () => {
    console.log(
      "editMasterFilling",
      "selectedCustomer",
      selectedCustomer,
      "selectedFiling",
      selectedFiling, "isTrackNowAccess", isTrackNowAccess, "isPostAwardAccess", isPostAwardAccess, "roleType", roleType
    );

    if (selectedClientId && selectedFiling && selectedFiling.length !== 0) {
      console.log("check3");

      if (selectedClientId && selectedFiling && selectedFiling.length > 1) {
        setAlertMessage("Please Select single Client specific Filing ");
        setShowAlert(true);
      } else {
        console.log("check4");

        if (!selectedFiling[0].isMasterFiling) {
          console.log("editMasterFilling", "consRecords", selectedFiling[0]);
          if (
            selectedFiling[0].recordType === "TrackNow" &&
            !isTrackNowAccess
          ) {
            console.log("check1");

            setAlertMessage("User doesn't have permission to edit Tracknow Filing");
            setShowAlert(true)
            return;
          }

          if (
            selectedFiling[0].recordType === "PostAward" &&
            !isPostAwardAccess
          ) {
            console.log("check2");

            setAlertMessage("User doesn't have permission to edit PostAward Filing");
            setShowAlert(true)

            return;
          }
          const list = await fetchAffectedCompanies();
          if (
            ((selectedCustomer?.clientType === "Parent" && !selectedCustomer.isOnlyParentFile) || (selectedCustomer?.clientType === "Child" && selectedCustomer?.bothChildAndSubChild))

          ) {
            const listConst = await axios.get(
              `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${selectedClientId}&FilingId=${selectedFiling[0].filingId}&PreviousStartDate=${selectedFiling[0].previousStartDate}`
            );
            console.log(
              "editMasterFilling list",
              list,
              "consRecords",
              listConst.data.data
            );
            const constRecords = listConst.data.data;
            const exsistingChildCompany = list.map((item) => {
              const matchingRecords = constRecords.find(
                (cust) => cust.customerId === item.customerId
              );
              console.log(",matchingRecords", matchingRecords, "item", item);
              if (matchingRecords) {
                selectedAffectedCompanies.push(matchingRecords.customerId);
                selectedAffectedCompaniesEdit.push(matchingRecords.customerId);
                selectedAffectedCompaniesEditInitial.push(
                  matchingRecords.customerId
                ); //prev customerId
                customerNames.push({
                  customerId: matchingRecords.customerId,
                  customerName: matchingRecords.customerName,
                }); //prev customername
                selectedAffectedCompaniesEditInitialNames.push({
                  customerId: matchingRecords.customerId,
                  customerName: matchingRecords.customerName,
                }); //prev customername
              }
              return {
                ...item,
                isDisabled: matchingRecords ? true : false,
              };
            });
            constRecords.forEach((record) => {
              if (record.customerId === selectedCustomer.customerId) {
                if (
                  !customerNames.some(
                    (cust) => cust.customerName === record.customerName
                  )
                ) {
                  console.log(
                    "record ",
                    record,
                    "customerNames",
                    customerNames,
                    "constRecords",
                    constRecords
                  );
                  customerNames.push({
                    customerId: record.customerId,
                    customerName: record.customerName,
                  });
                }
              }
            });

            setAffectedCompanyLists(exsistingChildCompany);
            setShowRadioEdit(true);
            // editFiling()
          } else {
            editFiling();
          }
        } else {
          setAlertMessage("Please Select a Client specific Filing to edit ");
          setShowAlert(true);
        }
      }
      //}
    } else {
      setAlertMessage("Please Select a Client specific Filing ");
      setShowAlert(true);
    }
  };
  console.log("affectedCompanyLists", affectedCompanyLists);
  const displayClientFiling = () => {
    navigate("/");
  };

  const displayCalendarView = () => {
    navigate(`/calendar/${selectedClientId}`, { state: { clientName: selectedCustomer?.customerName } });
  };

  // const getAttachment = async (fileTrackingId, commentsId) => {
  //   console.log(
  //     "getAttachment",
  //     selectedFiling.customerId,
  //     fileTrackingId,
  //     commentsId
  //   );
  //   const res = await axios.get(
  //     `${API_BASE_URL}/Customer/CustomerFilingTrackingCommentsAttachments?customerId=${selectedFiling.customerId}&fileTrackingId=${fileTrackingId}&commentsId=${commentsId}`
  //   );
  //   console.log(
  //     "updateFilePath res",
  //     res.data.data,
  //     res.data.data[0].attachmentPath
  //   );
  //   if (res.data) {
  //     return res.data.data[0].attachmentPath;
  //   }
  // };
  const getAttachment = async (customerId, fileTrackingId, commentsId) => {
    const res = await axios.get(
      `${API_BASE_URL}/Customer/CustomerFilingTrackingCommentsAttachments?customerId=${customerId}&fileTrackingId=${fileTrackingId}&commentsId=${commentsId}`
    );

    if (res.data) {
      return {
        attachmentPath: res.data.data[0].attachmentPath,
        attachmentId: res.data.data[0].attachmentId,
      };
    }
  };

  // const fetchClientFilingTrackerComments = async (fileTrackingId) => {
  //   console.log("@@Fetch FilingMasters1:", getClientFilingTrackerComments);
  //   if (getClientFilingTrackerComments) {
  //     console.log("@@Fetch FilingMasters2:");
  //     try {
  //       let commentList = await getClientFilingTrackerComments(fileTrackingId);
  //       commentList = await Promise.all(
  //         commentList.map(async (ele) => {
  //           console.log("commentList", ele);
  //           ele.attachmentPath = await getAttachment(
  //             ele.fileTrackingId,
  //             ele.commentsId
  //           );
  //           return ele;
  //         })
  //       );
  //       setComments(() => commentList);
  //       console.log("@@Fetch FilingMasters2 comments:", commentList);
  //     } catch (error) {
  //       console.log("@@Error:", error);
  //     }
  //   }
  // };

  const fetchClientFilingTrackerComments = async (
    fileTrackingId,
    customerId
  ) => {
    if (getClientFilingTrackerComments) {
      try {
        let commentList = await getClientFilingTrackerComments(fileTrackingId);
        commentList = await Promise.all(
          commentList.map(async (ele) => {
            const { attachmentPath, attachmentId } = await getAttachment(
              customerId || selectedFiling.customerId,
              ele.fileTrackingId,
              ele.commentsId
            );
            ele.attachmentPath = attachmentPath;
            ele.attachmentId = attachmentId;
            return ele;
          })
        );
        setComments(() => commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  // const addComment = (rowData) => {
  //   console.log("Display Comments", selectedFiling);
  //   console.log("Fetching Comments", selectedFiling);
  //   if (rowData && rowData.fileTrackingId) {
  //     console.log(`Fetching Commnet for :${rowData.fileTrackingId}`);
  //     fetchClientFilingTrackerComments(rowData.fileTrackingId);
  //     setShowComments(() => true);
  //     //setSelectedFiling(rowData);
  //   } else if (selectedFiling && selectedFiling.fileTrackingId) {
  //     console.log(`Fetching Commnet for :${selectedFiling.fileTrackingId}`);
  //     fetchClientFilingTrackerComments(selectedFiling.fileTrackingId);

  //     setShowComments(() => true);
  //   } else {
  //     setAlertMessage("Please Select a Filing Tracker Record");
  //     setShowAlert(true);
  //   }
  // };


  const displayOrganizationalStructure = async () => {

    if (selectedCustomer) {
      const res = await axios.get(`${API_BASE_URL}/Customer/CustomerList`, {
        params: {
          customerId: selectedCustomer.customerId,
        },
      });
      const fullCustomerDetails = res.data[0];

      // console.log(`Fetching Commnet for :${rowData.customerId}`);
      setOrganizationalStructure(fullCustomerDetails)
      setShowOrgStructure(() => true);

    }
  }
  const addComment = (rowData) => {
    console.log("Indicator Func addComment rowwdata", rowData);
    if (rowData && rowData.fileTrackingId) {
      fetchClientFilingTrackerComments(
        rowData.fileTrackingId,
        rowData.customerId
      );
      setShowComments(() => true);
      // setSelectedFiling(rowData);
    } else if (selectedFiling && selectedFiling[0]?.fileTrackingId) {
      if (selectedFiling.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        fetchClientFilingTrackerComments(
          selectedFiling[0]?.fileTrackingId,
          selectedFiling[0]?.customerId
        );
        setShowComments(() => true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  const fetchClientFilingTrackerAttachments = async (fileTrackingId) => {
    if (getClientFilingTrackerAttachments) {
      try {
        const attachmentList = await getClientFilingTrackerAttachments(
          fileTrackingId
        );
        setAttachments(() => attachmentList);
      } catch (error) { }
    }
  };

  const displayAttachments = async (rowData) => {
    console.log("Indicator Func displayAttachments rowwdata", rowData);
    if (rowData && rowData.fileTrackingId) {
      fetchClientFilingTrackerAttachments(rowData.fileTrackingId);
      setShowAttachments(() => true);
    } else if (selectedFiling && selectedFiling[0]?.fileTrackingId) {
      if (selectedFiling.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        fetchClientFilingTrackerAttachments(selectedFiling[0]?.fileTrackingId);
        setShowAttachments(() => true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  const fetchTrackerActive = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFileTrackingExportByCustomerId?CustomerId=${selectedClientId}`
      );
      console.log("fetchTrackerActive res", res);
      return res.data.data; // Assuming the response contains the data you need
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      throw error; // Propagate the error
    }
  };
  const fetchTrackerHistory = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFileTrackingExportByCustomerId?CustomerId=${selectedClientId}&Year=${selectedYear}`
      );
      // console.log("fetchTrackerHistory res", res);
      return res.data.data; // Assuming the response contains the data you need
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      throw error; // Propagate the error
    }
  };
  const stateMap = React.useMemo(() => {
    const map = new Map();
    if (states && Array.isArray(states)) {
      states.forEach((s) => map.set(s.code, s.state));
    }
    return map;
  }, [states]);

  const getStateName = (stateCode) => {
    return stateMap.get(stateCode) || stateCode;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const exportExcel = async (data) => {
    if (showDownloadProgress) return;
    setShowDownloadProgress(true);
    setDownloadProgress(10);
    setDownloadStatusMsg("Fetching filings from server...");

    let currentProgress = 10;
    const progressTimer = setInterval(() => {
      if (currentProgress < 85) {
        currentProgress += Math.floor(Math.random() * 5) + 3;
        if (currentProgress > 85) currentProgress = 85;
        setDownloadProgress(currentProgress);
        setDownloadStatusMsg(`Fetching filings from server (${currentProgress}%)...`);
      }
    }, 750);

    try {
      const resList = await fetchTrackerActive();
      clearInterval(progressTimer);

      if (!resList || resList.length === 0) {
        setShowDownloadProgress(false);
        setDownloadProgress(0);
        setAlertMessage("No data to download");
        setShowAlert(true);
        return;
      }

      setDownloadProgress(92);
      setDownloadStatusMsg(`Formatting ${resList.length.toLocaleString()} filing records...`);

      setTimeout(() => {
        const renamedData = resList.map((item) => {
          //Grant Term Complete
          const grantTermComplete =
            item.recordType === "TrackNow"
              ? ""
              : item.grantTermComplete === "Yes" ||
                item.grantTermComplete === true
                ? "Yes"
                : "No";
          //State
          const stateMod = getStateName(item.filingStateInfo);

          //Filing Period
          const formattedFilingPeriod = `${formatDate(
            item.filingPeriods.startdate
          )} - ${formatDate(item.filingPeriods.enddate)}`;

          //Filing Due Date
          const filingDueDateMod = item.filingDueDate
            ? formatDate(item.filingDueDate)
            : "";

          //Staff Assigned
          const staffAssigned = item.staffAssigned
            ? item.staffAssigned
              .map((staff) => {
                const capitalizedUserName =
                  staff.userName.charAt(0).toUpperCase() +
                  staff.userName.slice(1);
                return capitalizedUserName;
              })
              .join(", ")
            : "";

          const awardTypeName =
            item.awardType && item.awardType.length > 0
              ? item.awardType[0].awardTypeName
              : "";

          const awardingAgencyName =
            item.awardingAgency && item.awardingAgency.length > 0
              ? item.awardingAgency[0].awardingAgencyName
              : "";
          const programName =
            item.programInfo && item.programInfo.length > 0
              ? item.programInfo[0].programName
              : "";

          let whoMustFileFederalMod = "";
          let whoMustFileinStateMod = "";

          if (item.filingJuristiction === "Federal") {
            if (item.recordType === "TrackNow") {
              whoMustFileFederalMod = item.businessCategory
                .map((obj) => obj.businessCategoryName)
                .join(", ");
            } else if (item.recordType === "PostAward") {
              whoMustFileFederalMod = programName;
            }
          } else if (item.filingJuristiction === "State") {
            if (item.recordType === "TrackNow") {
              const filteredCategories = item.businessCategory.filter(
                (category) => category.state === item.filingStateInfo
              );
              whoMustFileinStateMod = filteredCategories
                .map((obj) => obj.businessCategoryName)
                .join(", ");
            } else if (item.recordType === "PostAward") {
              whoMustFileinStateMod = programName;
            }
          }

          return {
            "Filing Name": item.filingName,
            "Client Name": item.customerName,
            "Filing Due Date": filingDueDateMod,
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Filing Period": formattedFilingPeriod,
            }),
            Status: item.status,
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Grant Term Complete": grantTermComplete,
            }),
            "Staff Assigned": staffAssigned,
            "Filing Frequency": item.filingFrequency,
            State: stateMod,
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              "Rule Info": item.ruleInfo,
            }),
            Jurisdiction: item.filingJuristiction,
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              Required: item.filingRequired ? "True" : "False",
            }),
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Award Type": awardTypeName,
            }),
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Award Agency": awardingAgencyName,
            }),
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              "Who Must File Federal": whoMustFileFederalMod,
            }),
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              "Who Must File in State": whoMustFileinStateMod,
            }),
            "Record Type": item.recordType,
            "Where to File": item.whereToFile,
            Notes: item.notes,
          };
        });

        const worksheet = xlsx.utils.json_to_sheet(renamedData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
          compression: false,
        });

        setDownloadProgress(100);
        setDownloadStatusMsg("Download complete!");
        saveAsExcelFile(excelBuffer, "tracknowsheet");

        setTimeout(() => {
          setShowDownloadProgress(false);
          setDownloadProgress(0);
          setDownloadStatusMsg("");
        }, 400);
      }, 10);
    } catch (error) {
      clearInterval(progressTimer);
      console.log("error", error);
      setShowDownloadProgress(false);
      setDownloadProgress(0);
      setAlertMessage("Error downloading Excel file");
      setShowAlert(true);
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });

    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  };
  const exportExcelHistory = async () => {
    if (showDownloadProgress) return;
    setShowDownloadProgress(true);
    setDownloadProgress(10);
    setDownloadStatusMsg("Fetching history filings from server...");

    let currentProgress = 10;
    const progressTimer = setInterval(() => {
      if (currentProgress < 85) {
        currentProgress += Math.floor(Math.random() * 5) + 3;
        if (currentProgress > 85) currentProgress = 85;
        setDownloadProgress(currentProgress);
        setDownloadStatusMsg(`Fetching history filings from server (${currentProgress}%)...`);
      }
    }, 750);

    try {
      const resList = await fetchTrackerHistory();
      clearInterval(progressTimer);

      if (!resList || resList.length === 0) {
        setShowDownloadProgress(false);
        setDownloadProgress(0);
        setAlertMessage("No data to download");
        setShowAlert(true);
        return;
      }

      setDownloadProgress(92);
      setDownloadStatusMsg(`Formatting ${resList.length.toLocaleString()} history records...`);

      setTimeout(() => {
        const renamedData = resList.map((item) => {
          //Grant Term Complete
          const grantTermComplete =
            item.recordType === "TrackNow"
              ? ""
              : item.grantTermComplete === "Yes" ||
                item.grantTermComplete === true
                ? "Yes"
                : "No";
          //State
          const stateMod = getStateName(item.filingStateInfo);

          //Filing Period
          const formattedFilingPeriod = `${formatDate(
            item.filingPeriods.startdate
          )} - ${formatDate(item.filingPeriods.enddate)}`;

          //Filing Due Date
          const filingDueDateMod = item.filingDueDate
            ? formatDate(item.filingDueDate)
            : "";

          //Staff Assigned
          const staffAssigned = item.staffAssigned
            ? item.staffAssigned
              .map((staff) => {
                const capitalizedUserName =
                  staff.userName.charAt(0).toUpperCase() +
                  staff.userName.slice(1);
                return capitalizedUserName;
              })
              .join(", ")
            : "";

          const awardTypeName =
            item.awardType && item.awardType.length > 0
              ? item.awardType[0].awardTypeName
              : "";

          const awardingAgencyName =
            item.awardingAgency && item.awardingAgency.length > 0
              ? item.awardingAgency[0].awardingAgencyName
              : "";
          const programName =
            item.programInfo && item.programInfo.length > 0
              ? item.programInfo[0].programName
              : "";

          let whoMustFileFederalMod = "";
          let whoMustFileinStateMod = "";

          if (item.filingJuristiction === "Federal") {
            if (item.recordType === "TrackNow") {
              whoMustFileFederalMod = item.businessCategory
                .map((obj) => obj.businessCategoryName)
                .join(", ");
            } else if (item.recordType === "PostAward") {
              whoMustFileFederalMod = programName;
            }
          } else if (item.filingJuristiction === "State") {
            if (item.recordType === "TrackNow") {
              const filteredCategories = item.businessCategory.filter(
                (category) => category.state === item.filingStateInfo
              );
              whoMustFileinStateMod = filteredCategories
                .map((obj) => obj.businessCategoryName)
                .join(", ");
            } else if (item.recordType === "PostAward") {
              whoMustFileinStateMod = programName;
            }
          }
          return {
            "Filing Name": item.filingName,
            "Client Name": item.customerName,
            "Filing Due Date": filingDueDateMod,
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Filing Period": formattedFilingPeriod,
            }),
            Status: item.status,
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Grant Term Complete": grantTermComplete,
            }),
            "Staff Assigned": staffAssigned,
            "Filing Frequency": item.filingFrequency,
            State: stateMod,
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              "Rule Info": item.ruleInfo,
            }),
            Jurisdiction: item.filingJuristiction,
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              Required: item.filingRequired ? "True" : "False",
            }),
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Award Type": awardTypeName,
            }),
            ...(selectedCustomer.postAwardLicenseId > 0 && {
              "Award Agency": awardingAgencyName,
            }),
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              "Who Must File Federal": whoMustFileFederalMod,
            }),
            ...(selectedCustomer.trackNowLicenseId > 0 && {
              "Who Must File in State": whoMustFileinStateMod,
            }),
            "Record Type": item.recordType,
            "Where to File": item.whereToFile,
            Notes: item.notes,
          };
        });

        const worksheet = xlsx.utils.json_to_sheet(renamedData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
          compression: false,
        });
        saveAsExcelFileHistory(excelBuffer, "tracknowsheet");

        setDownloadProgress(100);
        setDownloadStatusMsg("Download complete!");

        setTimeout(() => {
          setShowDownloadProgress(false);
          setDownloadProgress(0);
          setDownloadStatusMsg("");
        }, 400);
      }, 10);
    } catch (error) {
      clearInterval(progressTimer);
      console.log("error", error);
      setShowDownloadProgress(false);
      setDownloadProgress(0);
      setAlertMessage("Error downloading Excel file");
      setShowAlert(true);
    }
  };

  const saveAsExcelFileHistory = (buffer, fileName) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });

    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  };

  const displayDocuments = async (rowData) => {
    console.log("Indicator Func displayDocuments rowwdata", rowData);
    if (rowData && rowData.filingId) {
      fetchFilingMasterDocuments(rowData.filingId);
      setShowDocuments(() => true);
    } else if (selectedFiling && selectedFiling[0]?.customerId) {
      if (selectedFiling.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        fetchFilingMasterDocuments(selectedFiling[0]?.filingId);
        setShowDocuments(() => true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };
  const displayConsolidatedView = async (rowData) => {
    console.log("displayConsolidatedView rowData", rowData);
    console.log("displayConsolidatedView selectedFiling", selectedFiling);

    if (selectedFiling && selectedFiling[0]?.customerId) {
      if (selectedFiling.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        console.log("selectedFiling[0]");
        if (selectedFiling[0].isUnderParent) {
          // under parent view

          // if (selectedFiling[0].isOnlyParentFile && !selectedFiling[0].isOnlyChildFile) {
          //   //Filing got affected only in parent company not any child
          //   setAlertMessage("There is no affected child company for the selected filing");
          //   setShowAlert(true);
          // } else {

          // Filing got affected only in child company and  both parent and child company
          fetchConsolidatedRecords(selectedFiling[0]);
          setShowConsolidated(() => true);

          // }
        } else {
          // under Single company or child view
          setAlertMessage(
            "Under this client, there is no affected child company."
          );
          setShowAlert(true);
        }
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };
  // const displayClientSpecificConsolidatedView = async (rowData) => {

  //   console.log("displayClientSpecificConsolidatedView rowData", rowData);
  //   console.log("displayClientSpecificConsolidatedView selectedFiling", selectedFiling);

  //   if (selectedFiling && selectedFiling[0]?.customerId) {
  //     if (selectedFiling.length > 1) {
  //       setAlertMessage("Please Select single Filing Tracker Record");
  //       setShowAlert(true);
  //     } else {
  //       if (!selectedFiling[0].isMasterFiling) {

  //         if (selectedFiling[0].isUnderParent) {
  //           // under parent view
  //           fetchAffectedCompanies(selectedFiling[0]);
  //           setShowClientSpecificConsolidated(() => true);
  //         } else {
  //           // under Single company or child view
  //           setAlertMessage("Under this client, there is no affected child company.");
  //           setShowAlert(true);
  //         }
  //         //master filing record check

  //       } else {
  //         setAlertMessage("Please select a client specific filing");
  //         setShowAlert(true);
  //       }
  //     };
  //   } else {
  //     setAlertMessage("Please Select a Filing Tracker Record");
  //     setShowAlert(true);
  //   }
  // };

  const fetchFilingMasterDocuments = async (filingId) => {
    try {
      const attachmentList = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
      );
      setDocuments(() => attachmentList.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const fetchConsolidatedRecords = async (selectedFiling) => {
    console.log("fetchConsolidatedRecords filingId", selectedFiling);
    try {
      const consRecords = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${selectedClientId}&FilingId=${selectedFiling.filingId}&PreviousStartDate=${selectedFiling.previousStartDate}`
      );
      const consStatus = await axios.get(
        `${API_BASE_URL}/Customer/ConsolidateStatusForTracker?CustomerId=${selectedClientId}&FilingId=${selectedFiling.filingId}&previousStartDate=${selectedFiling.previousStartDate}`
      );
      console.log(
        "fetchConsolidatedRecords consRecords",
        consRecords,
        "consStatus",
        consStatus
      );
      setConsolidatedRecords(() => consRecords.data.data);
      setConsolidatedRecordsStatus(() => consStatus.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const fetchAffectedCompanies = async () => {
    console.log("fetchAffectedCompanies filingId", selectedFiling);
    try {
      const list = await axios.get(
        `${API_BASE_URL}/Customer/CustomerListBasedOnParentId?CustomerId=${selectedClientId}`
      );
      console.log("fetchAffectedCompanies list", list);
      //const filteredList = list.data.data.filter(item => item.parentCustomerId !== 0);

      setAffectedCompanyLists(list.data.data); // Assuming setAffectedCompanyLists is a state setter
      return list.data.data; // Returning the fetched data
    } catch (error) {
      console.log("@@Error:", error);
      throw error; // Re-throwing the error for potential handling elsewhere
    }
  };
  const fetchClientTrackingHistory = async (fileTrackingId) => {
    try {
      const history = await axios.get(
        `${API_BASE_URL}/Customer/customerfilingtrackingaudit?FileTrackingID=${fileTrackingId}`
      );
      setActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsTnHistoryLoading(false);
    }

    try {
      const history = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFilingMasterAudit${selectedFiling[0].customerId}?FilingId=${selectedFiling[0].filingId}`
      );
      setClientActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsCfHistoryLoading(false);
    }

    try {
      let fileTrackingIds = selectedFiling[0]?.fileTrackingId;

      if (!detailedViewVal) {
        const targetCustomerId = (selectedCustomer && selectedCustomer.customerId)
          ? selectedCustomer.customerId
          : (selectedClientId ? parseInt(selectedClientId) : selectedFiling[0]?.customerId);

        let payload = [
          {
            customerId: targetCustomerId,
            filingId: selectedFiling[0].filingId,
            PreviousStartDate: selectedFiling[0].previousStartDate,
          },
        ];

        const res = await axios.post(
          `${API_BASE_URL}/Customer/CustomerandFilingListBasedOnParentdetails`,
          payload
        );
        if (res?.data?.data?.length > 0) {
          fileTrackingIds = res.data.data
            .map((item) => item.fileTrackingId)
            .join(",");
        }
      }

      const history = await axios.get(
        `${API_BASE_URL}/Customer/customerfilingtrackingcommentaudit?FileTrackingId=${fileTrackingIds}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsCommentsHistoryLoading(false);
    }
  };

  const displayHistory = async () => {
    if (selectedFiling && selectedFiling[0]?.fileTrackingId) {
      if (selectedFiling && selectedFiling.length > 1) {
        setAlertMessage("Please Select single Filing Tracker Record");
        setShowAlert(true);
      } else {
        fetchClientTrackingHistory(selectedFiling[0]?.fileTrackingId);
        setShowHistory(() => true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };
  const updateBulkStatus = async () => {
    if (selectedFiling && selectedFiling[0]?.fileTrackingId) {
      if (selectedFiling && selectedFiling.length > 1) {

        let payload1 = selectedFiling.map((ele) => {
          return {
            customerId: ele.customerId,
            filingId: ele.filingId,
            PreviousStartDate: ele.previousStartDate,
            customerType: selectedCustomer.clientType
          };
        });
        console.log("updateBulkStatus payload1", payload1, selectedFiling);
        if (detailedViewVal) {
          const res = await axios.post(
            `${API_BASE_URL}/Customer/CustomerandFilingListBasedOnParentdetailsandCommonstaffsForDetailedView`,
            payload1
          );
          console.log("updateBulkStatus res", res.data);
          setBulkUpdateRecords(res.data.data.trackingList);
          setCommonStaffs(res.data.data.multipleFilingCommonStaff);
        } else {
          const res = await axios.post(
            `${API_BASE_URL}/Customer/CustomerandFilingListBasedOnParentdetailsandCommonstaffs`,
            payload1
          );
          console.log("updateBulkStatus res", res.data);
          setBulkUpdateRecords(res.data.data.trackingList);
          setCommonStaffs(res.data.data.multipleFilingCommonStaff);
        }
        // fetchClientTrackingHistory(selectedFiling.fileTrackingId);
        // setShowHistory(() => true);


        setShowBulkStatusDrawer(() => true);
      } else {
        setAlertMessage(
          "Please Select more than one Filing Tracker Record for bulk status update"
        );
        setShowAlert(true);
      }
    } else {
      setAlertMessage("Please Select a Filing Tracker Record");
      setShowAlert(true);
    }
  };

  const closeOrgStucture = () => {
    setShowOrgStructure(() => false);
    setOrganizationalStructure({})
  };
  const closeComments = () => {
    setShowComments(() => false);
  };

  const closeAttachments = () => {
    setShowAttachments(() => false);
  };

  const closeDocuments = () => {
    setShowDocuments(() => false);
  };
  const closeConsolidated = () => {
    setShowConsolidated(() => false);
  };
  // const closeClentSpecificConsolidated = () => {
  //   setShowClientSpecificConsolidated(() => false);
  // };

  const closeHistory = () => {
    setShowHistory(() => false);
  };

  const footerContent = (
    <div>
      <TrackNowButton variant="primary" onClick={() => closeAlert()}>
        OK
      </TrackNowButton>
    </div>
  );
  const radioFooterContent = (
    <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
      <TrackNowButton variant="tertiary" onClick={() => radioCloseAlert()}>
        Cancel
      </TrackNowButton>
      <TrackNowButton variant="primary" onClick={() => radioOkButton()}>
        Submit
      </TrackNowButton>
    </div>
  );
  const radioFooterContent1 = (
    <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
      <TrackNowButton variant="tertiary" onClick={() => radioCloseAlert1()}>
        Cancel
      </TrackNowButton>
      <TrackNowButton
        variant="primary"
        onClick={() => radioOkButton1()}
        disabled={
          ((!selectedCustomer?.parentCustomer ||
            selectedCustomer?.parentCustomer === null) &&
            !selectedCustomer?.isOnlyParentFile &&
            selectedAffectedCompanies.length === 0) || (
            selectedCustomer?.clientType === "Child" &&
            selectedCustomer?.bothChildAndSubChild &&
            selectedAffectedCompanies?.length === 0
          )
        }
      >
        Submit
      </TrackNowButton>
    </div>
  );
  const radioFooterContentEdit = (
    <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
      <TrackNowButton variant="tertiary" onClick={() => radioCloseAlertEdit()}>
        Cancel
      </TrackNowButton>
      <TrackNowButton variant="primary" onClick={() => radioOkButtonEdit()}>
        Submit
      </TrackNowButton>
    </div>
  );

  const closeAlert = () => {
    setShowAlert(false);
  };
  const radioCloseAlert = () => {
    setShowRadio(false);
  };
  const radioCloseAlert1 = () => {
    setSelectedAffectedCompanies([]);
    setSelectedAffectedCompaniesEdit([]);
    setShowRadio1(false);
    setCustomerNames([]);
    setSelectedAffectedCompaniesEditInitial([]);
    setSelectedAffectedCompaniesEditInitialNames([]);
  };
  const radioCloseAlertEdit = () => {
    setSelectedAffectedCompanies([]);
    setSelectedAffectedCompaniesEdit([]);
    setSelectedAffectedCompaniesEditInitial([]);
    setSelectedAffectedCompaniesEditInitialNames([]);
    setShowRadioEdit(false);
    setCustomerNames([]);
  };

  const refreshAttachments = () => {
    setRefreshList(true);
  };

  const resetRefreshList = () => {
    setRefreshList(false);
  };

  const handleRadioChange = (event) => {
    setRadioVal(event.target.value);
  };
  // const handleRadioChange1 = (event) => {
  //   const newValue = event.target.value;
  //   // Only allow changing if client has both licenses
  //   if (
  //     selectedCustomer?.trackNowLicenseId &&
  //     selectedCustomer?.trackNowLicenseId > 0 &&
  //     selectedCustomer?.postAwardLicenseId &&
  //     selectedCustomer?.postAwardLicenseId > 0
  //   ) {
  //     setSelectedAffectedCompanies([]);
  //     setSelectedAffectedCompaniesEdit([]);
  //     setRadioVal1(radioVal1 === newValue ? '' : newValue);
  //   }
  // };
  const handleRadioChange1 = (event) => {
    setSelectedAffectedCompanies([]);
    setSelectedAffectedCompaniesEdit([]);
    setRadioVal1(event.target.value);
  };
  const radioOkButton = () => {
    if (radioVal === "tracknow") {
      navigate(`/add-filings/${selectedClientId}`, { state: { clientName: selectedCustomer?.customerName } });
    } else {
      navigate(`/add-filing-postaward/${selectedClientId}`, { state: { clientName: selectedCustomer?.customerName } });
    }
  };

  const radioOkButton1 = () => {
    console.log(
      "radioOkButton1 selectedAffectedCompanies",
      selectedAffectedCompanies
    );
    try {
      if (roleType.length > 1) {
        //incase user has two roles
        if (isTrackNowAccess && isPostAwardAccess) {
          //if user has both TN and PA access
          if (radioVal1 === "tracknow") {
            navigate("/filing-master", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                from: "/client-filing-tracker-list",
                mode: "add",
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          } else {
            navigate("/postaward-master-form", {
              state: {
                selectedAffectedCompanies,
                customerNames,
                from: "/client-filing-tracker-list",
              },
            });
            fetchCustomerList();
            onAddClientSpecificFilingClick(true);
          }
        } else if (isTrackNowAccess) {
          //TN roles
          navigate("/filing-master", {
            state: {
              selectedAffectedCompanies,
              customerNames,
              from: "/client-filing-tracker-list",
              mode: "add",
            },
          });
          fetchCustomerList();
          onAddClientSpecificFilingClick(true);
        } else {
          //PA roles
          navigate("/postaward-master-form", {
            state: {
              selectedAffectedCompanies,
              customerNames,
              from: "/client-filing-tracker-list",
            },
          });
          fetchCustomerList();
          onAddClientSpecificFilingClick(true);
        }
      } else if (isTrackNowAccess) {
        //TN roles
        navigate("/filing-master", {
          state: {
            selectedAffectedCompanies,
            customerNames,
            from: "/client-filing-tracker-list",
            mode: "add",
          },
        });
        fetchCustomerList();
        onAddClientSpecificFilingClick(true);
      } else if (isPostAwardAccess) {
        //PA roles
        navigate("/postaward-master-form", {
          state: {
            selectedAffectedCompanies,
            customerNames,
            from: "/client-filing-tracker-list",
          },
        });
        fetchCustomerList();
        onAddClientSpecificFilingClick(true);
      }
    } catch (error) {
      console.error("radioOkButton1", error);
    } finally {
      setSelectedAffectedCompanies([]);
      setSelectedAffectedCompaniesEdit([]);
      setCustomerNames([]);
      setSelectedAffectedCompaniesEditInitial([]);
      setSelectedAffectedCompaniesEditInitialNames([]);
    }
  };
  const radioOkButtonEdit = () => {
    editFiling();
  };

  const deleteMasterRecord = async () => {
    if (selectedFiling) {
      if (
        selectedFiling[0].status === "Completed" ||
        selectedFiling[0].status === "Approved"
      ) {
        setAlertMessage(
          <Typography>
            Unable to delete this{" "}
            <Typography fontWeight="bold" component="span">
              {selectedFiling[0].filingName}
            </Typography>{" "}
            as Status has been Approved or completed.
          </Typography>
        );
        setShowAlert(true);
      } else {
        // try {
        //   let payLoad = { ...selectedFiling };
        //   //payLoad.changesInprogress = undefined;
        //   payLoad.createUser = authUser.userId + "";
        //   payLoad.createDate = new Date();
        //   const res = await deleteDraftFilingMaster(payLoad);
        //   console.log("Draft Res:", res);
        //   if (res) {
        //     const wfPayload = {
        //       draftId: res.draftId,
        //       // currentApproverId: 1,
        //       WorkflowInitiatorId: authUser?.userId + "",
        //       createUser: authUser?.userId + "",
        //       createDate: new Date(),
        //     };
        //     let res3 = null;
        //     if (createFilingMasterWorkflow) {
        //       res3 = await createFilingMasterWorkflow(wfPayload);
        //     }
        //     console.log("handleDelete res3", res3);
        //     if (res3 !== null) {
        //       setCurrentFilingMaster(null);

        //       setAlertMessage(
        //         <Typography>
        //           This{" "}
        //           <Typography fontWeight="bold" component="span">
        //             {selectedFiling.filingName}
        //           </Typography>{" "}
        //           has been successfully deleted from Client Filings List.
        //         </Typography>
        //       );
        //       setShowAlert(true);
        //       setRefreshList(true);
        //       closeDialog();
        //     }
        //   } else {
        //     setAlertMessage(
        //       <Typography>
        //         Unexpected error occured while deleting{" "}
        //         <Typography fontWeight="bold" component="span">
        //           {selectedFiling.filingName}
        //         </Typography>{" "}
        //       </Typography>
        //     );
        //     setShowAlert(true);
        //     closeDialog();
        //   }
        // }
        try {
          let payload = [
            {
              fileTrackingId: selectedFiling[0].fileTrackingId,
              customerId: selectedFiling[0].customerId,
              filingId: selectedFiling[0].filingId,
              year: new Date(selectedFiling[0].startdate).getFullYear() + "",
              UserId: authUser.userId + "",
            },
          ];
          // console.log("CustomerFilingDelete payload", payload, "selectedFiling", selectedFiling[0]);
          try {
            const res = await axios.post(
              `${API_BASE_URL}/Customer/CustomerFilingDelete`,
              payload
            );
            if (res) {
              setCurrentFilingMaster(null);
              setAlertMessage(
                <Typography>
                  This{" "}
                  <Typography fontWeight="bold" component="span">
                    {selectedFiling[0].filingName}
                  </Typography>{" "}
                  has been successfully deferred.
                </Typography>
              );
              setShowAlert(true);
              refreshSelectedRecord()
              closeDialog();
            }
          } catch (error) {
            console.log("deleteRecord @@Error:", error);
            setAlertMessage(
              <Typography>
                Unexpected error occured while deleting{" "}
                <Typography fontWeight="bold" component="span">
                  {selectedFiling[0].filingName}
                </Typography>{" "}
              </Typography>
            );
            setShowAlert(true);
            closeDialog();
          }
        } catch (error) {
          console.log("@@Error:", error);
        }
      }
    } else {
      showAlert("Info", "Please Select a Master Record", "info");
      closeDialog();
    }
  };

  const deleteRecord = async () => {
    let payload = [
      {
        fileTrackingId: selectedFiling[0].fileTrackingId,
        customerId: selectedFiling[0].customerId,
        filingId: selectedFiling[0].filingId,
        year: new Date(selectedFiling[0].startdate).getFullYear() + "",
        UserId: authUser.userId + "",
      },
    ];
    try {
      // console.log("CustomerFilingDelete payload", payload, "selectedFiling", selectedFiling[0]);
      const res = await axios.post(
        `${API_BASE_URL}/Customer/CustomerFilingDelete`,
        payload
      );
      if (res) {
        setCurrentFilingMaster(null);
        setAlertMessage(
          <Typography>
            Successfully deferred filing :{" "}
            <Typography fontWeight="bold" component="span">
              {selectedFiling[0].filingName}
            </Typography>{" "}
          </Typography>
        );
        setShowAlert(true);
        refreshSelectedRecord()
        closeDialog();
      }
    } catch (error) {
      setAlertMessage(
        <Typography>
          Unexpected Error occured while deleting filing :{" "}
          <Typography fontWeight="bold" component="span">
            {selectedFiling[0].filingName}
          </Typography>{" "}
        </Typography>
      );
      setShowAlert(true);
      closeDialog();
    }
  };
  const deleteClientFiling = async () => {

    let payload = [
      {
        FileTrackingID: selectedFiling[0].fileTrackingId,
        customerId: selectedFiling[0].customerId,
        filingId: selectedFiling[0].filingId,
        year: new Date(selectedFiling[0].startdate).getFullYear() + "",
        UserId: authUser.userId + "",
      },
    ];
    try {
      console.log(
        "CustomerFileTrackerSpecificFilingDelete payload",
        payload,
        "selectedFiling",
        selectedFiling[0]
      );
      const res = await axios.post(
        `${API_BASE_URL}/Customer/CustomerFileTrackerSpecificFilingDelete`,
        payload
      );
      if (res) {
        setAlertMessage(
          <Typography>
            Successfully deleted:{" "}
            <Typography fontWeight="bold" component="span">
              {selectedFiling[0].filingName}
            </Typography>{" "}
          </Typography>
        );
        setShowAlert(true);
        refreshSelectedRecord()
        closeDialog();
      }
    } catch (error) {
      setAlertMessage(
        <Typography>
          Unexpected Error occured while deleting :{" "}
          <Typography fontWeight="bold" component="span">
            {selectedFiling[0].filingName}
          </Typography>{" "}
        </Typography>
      );
      setShowAlert(true);
      closeDialog();
    }
  };

  const handleSubmit = () => {
    // deleteCategory();

    if (isDeleteClientFiling) {
      deleteClientFiling();
      setIsDeleteClientFiling(false);
    } else if (selectedFiling[0].isMasterFiling) {
      deleteRecord();
    } else {
      deleteMasterRecord();
    }
  };

  const closeConfirm = () => { };

  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: () => handleSubmit(),
    onClose: closeConfirm,
  });

  const handleDelete = async () => {
    console.log("handleDelete selectedFiling", selectedFiling, selectedClientId);

    if (selectedFiling.length === 0) {
      setAlertMessage("Please Select a Client specific Filing");
      setShowAlert(true);
    } else if (selectedFiling.length > 1) {
      setAlertMessage("Please Select a single Client specific Filing");
      setShowAlert(true);
    } else {
      if (!selectedFiling[0].isMasterFiling) {
        if (selectedFiling[0].status === "Approved" || selectedFiling[0].status === "Completed") {
          setAlertMessage(
            <Typography>
              Unable to delete this{" "}
              <Typography fontWeight="bold" component="span">
                {selectedFiling[0].filingName}
              </Typography>{" "}
              as Status has been Approved or completed.
            </Typography>
          );
          setShowAlert(true);
        } else {
          if (!underDetailedViewProps) {
            try {
              const consRecords = await axios.get(
                `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${selectedClientId}&FilingId=${selectedFiling[0].filingId}&PreviousStartDate=${selectedFiling[0].previousStartDate}`
              );
              const consolidatedCount = consRecords?.data?.data?.length || 0;

              if (consolidatedCount > 1) {
                setAlertMessage(
                  "This filing is shared across multiple clients. To delete it, please navigate to the Detailed View."
                );
                setShowAlert(true);
                return;
              }
            } catch (error) {
              console.log("@@Error:", error);
              setAlertMessage("Unable to validate shared client filing details. Please try again.");
              setShowAlert(true);
              return;
            }
          }

          setIsDeleteClientFiling(true)
          showDialog(
            "Confirmation",
            <Typography>
              Are you sure you want to delete this{" "}
              <Typography fontWeight="bold" component="span">
                {selectedFiling[0].filingName}
              </Typography>{" "}
              record?{" "}
            </Typography>,
            "confirm"
          );
        }
      } else {
        setAlertMessage("Please Select a Client specific Filing to delete");
        setShowAlert(true);
      }
    }
  };


  const handleDeleteRecord = async () => {
    console.log(
      "handleDeleteRecord selectedClientId",
      selectedClientId,
      "selectedFiling",
      selectedFiling, "clientFilingData", clientFilingData
    );

    // const filteredFilingName = clientFilingData.filter(
    //   (item) => item.filingName === selectedFiling[0]?.filingName
    // );
    // const isStatusPending = filteredFilingName.every(
    //   (item) => item.status === "Pending"
    // );
    // const isStatusCompleted = filteredFilingName.some(
    //   (item) => item.status === "Completed" || item.status === "Approved"
    // );
    // console.log("handleDeleteRecord filteredFilingName", filteredFilingName, "isStatusPending", isStatusPending, "isStatusCompleted", isStatusCompleted);

    if (selectedClientId && selectedFiling && selectedFiling.length === 1) {
      if (
        selectedClientId &&
        selectedFiling &&
        (selectedFiling[0].status === "Completed" ||
          selectedFiling[0].status === "Approved")
      ) {
        setAlertMessage(
          <Typography>
            Unable to defer this{" "}
            <Typography fontWeight="bold" component="span">
              {selectedFiling[0].filingName}
            </Typography>{" "}
            as Status has been Approved or completed.
          </Typography>
        );
        setShowAlert(true);
      } else if (
        (selectedFiling[0].isOnlyChildFile || selectedFiling[0].isOnlySubchildFile) &&
        selectedFiling[0].isUnderParent &&
        !underDetailedViewProps
      ) {
        setAlertMessage(
          "Only Parent filing is allowed to defer. Please try to defer from Consolidated view or Detailed view or Child company (child view)"
        );
        setShowAlert(true);
      } else {
        if (!underDetailedViewProps) {
          try {
            const consRecords = await axios.get(
              `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${selectedClientId}&FilingId=${selectedFiling[0].filingId}&PreviousStartDate=${selectedFiling[0].previousStartDate}`
            );
            const consolidatedCount = consRecords?.data?.data?.length || 0;

            if (consolidatedCount > 1) {
              setAlertMessage(
                "This filing is shared across multiple clients. To Defer it, please navigate to the Detailed / Consolidate Update View."
              );
              setShowAlert(true);
              return;
            }
          } catch (error) {
            console.log("@@Error:", error);
            setAlertMessage("Unable to validate shared client filing details. Please try again.");
            setShowAlert(true);
            return;
          }
        }

        const currentYear = await axios.get(
          `${API_BASE_URL}/Customer/GetConfigValue?ConfigItem=CurrentYear`
        );
        const filingDateSource =
          selectedFiling[0].filingDueDate ||
          selectedFiling[0].filingPeriods?.enddate;
        const filingDueDateYear = filingDateSource
          ? new Date(filingDateSource).getFullYear()
          : 0;
        const currentYearValue = Number(currentYear.data);
        const isPastYear = filingDueDateYear < currentYearValue;
        if (isPastYear) {
          showDialog(
            "Confirmation",
            <Typography>
              If you defer a past year's due date filing, it will be deleted from the tracker list and not moved to the deferred list.
              Are you certain you want to proceed?
            </Typography>,
            "confirm"
          );
        } else {
          showDialog(
            "Confirmation",
            <Typography>
              Are you sure you want to move this{" "}
              <Typography fontWeight="bold" component="span">
                {selectedFiling[0].filingName}
              </Typography>{" "}
              to deferred list?{" "}
            </Typography>,
            "confirm"
          );
        }
      }
    } else {
      if (selectedFiling.length > 1) {
        setAlertMessage("Please select a single filing ");
        setShowAlert(true);
      } else {
        setAlertMessage("Please select a filing ");
        setShowAlert(true);
      }
    }
  };


  useEffect(() => {
    if (clientId) setSelectedClientId(clientId);
    //eslint-disable-next-line
    const hasTrackNowAccess = Boolean(
      roleType?.includes("ClientAdmin") ||
      roleType?.includes("Admin") ||
      roleType?.includes("JSIPOC") ||
      roleType?.includes("HierarchyAdmin")
    );
    const hasPostAwaradAccess = Boolean(
      roleType?.includes("ClientAdmin-PostAward") ||
      roleType?.includes("Admin-PostAward") ||
      roleType?.includes("JSIPOC-PostAward") ||
      roleType?.includes("HierarchyAdmin-PostAward")
    );
    console.log("roleType ", roleType, "hasTrackNowAccess", hasTrackNowAccess, " hasPostAwaradAccess", hasPostAwaradAccess);

    setIsTrackNowAccess(hasTrackNowAccess);
    setIsPostAwardAccess(hasPostAwaradAccess);
  }, [clientId]);

  useEffect(() => {
    // Check conditions and set the initial radio value based on client licenses
    if (
      selectedCustomer?.trackNowLicenseId &&
      selectedCustomer?.trackNowLicenseId > 0 &&
      (selectedCustomer?.postAwardLicenseId === null || selectedCustomer?.postAwardLicenseId === 0)
    ) {
      // Client has only TrackNow
      setRadioVal1("tracknow");
    } else if (
      selectedCustomer?.postAwardLicenseId &&
      selectedCustomer?.postAwardLicenseId > 0 &&
      (selectedCustomer?.trackNowLicenseId === null || selectedCustomer?.trackNowLicenseId === 0)
    ) {
      // Client has only PostAward
      setRadioVal1("postaward");
    } else if (
      selectedCustomer?.trackNowLicenseId &&
      selectedCustomer?.trackNowLicenseId > 0 &&
      selectedCustomer?.postAwardLicenseId &&
      selectedCustomer?.postAwardLicenseId > 0
    ) {
      // Client has both - default to tracknow
      setRadioVal1("tracknow");
    }
  }, [selectedCustomer]);

  // useEffect(() => {
  //   if (selectedCustomer) {
  //     setSelectedClientId(() => selectedCustomer.customerId);
  //   }
  //   //eslint-disable-next-line
  // }, [selectedCustomer]);
  // console.log("Props-check", "selectedClientId", selectedClientId, "selectedCustomer", selectedCustomer, "tablValue", tablValue, "selectedYear", selectedYear);
  const normalizeSelectedIds = (value) => {
    if (Array.isArray(value)) {
      return [...new Set(value.map((id) => String(id)))];
    }

    if (typeof value === "string") {
      return [...new Set(value.split(",").filter(Boolean).map((id) => String(id)))];
    }

    return [];
  };
  const getCompanyNameById = (list, id) => {
    const match = list.find((company) => String(company.customerId) === String(id));
    return match?.customerName || String(id);
  };
  const getCompanySelectionSummary = (selected, list) => {
    const ids = normalizeSelectedIds(selected);
    if (ids.length === 0) return "Select Company";
    const firstName = getCompanyNameById(list, ids[0]);
    const extraCount = ids.length - 1;
    if (extraCount <= 0) return firstName;
    const suffix = ` + ${extraCount} more`;
    const maxSummaryLength = 26;
    const reservedForEllipsis = 3;
    const maxFirstPart = Math.max(
      8,
      maxSummaryLength - suffix.length - reservedForEllipsis
    );
    const compactFirstName =
      firstName.length > maxFirstPart
        ? `${firstName.slice(0, maxFirstPart).trimEnd()}...`
        : firstName;
    return `${compactFirstName}${suffix}`;
  };
  const renderCompanySelectedItem = (value, selectedValues) => {
    const ids = normalizeSelectedIds(selectedValues).map((id) => String(id));
    if (ids.length === 0) return "Select Company";
    if (String(value) !== ids[0]) return null;
    return getCompanySelectionSummary(ids, affectedCompanyListsDropdown);
  };

  const companySelectOptions = affectedCompanyListsDropdown.map((company) => ({
    label: company.customerName,
    value: String(company.customerId),
    disabled: Boolean(company.isDisabled),
  }));
  const renderCompanyPanelHeader = (options) => (
    <div className={options.className}>
      <div className="company-dialog-multiselect-header">
        <div className="company-dialog-multiselect-header-left">
          {options.checkboxElement}
          <span>Select All</span>
        </div>
      </div>
    </div>
  );
  const handleChildCompanyChange = (e, affectedCompanyListsDropdown) => {
    console.log("handleChildCompanyChange", "e", e);
    const nextValue = normalizeSelectedIds(e?.target?.value ?? e?.value);
    const selectedCompanyNames = nextValue.map((selectedId) => {
      const selectedCompany = affectedCompanyListsDropdown.find(
        (company) => String(company.customerId) === String(selectedId)
      );
      return selectedCompany
        ? {
          customerId: selectedCompany.customerId,
          customerName: selectedCompany.customerName,
        }
        : []; // Return customerName if found, otherwise an empty string
    });
    setCustomerNames(selectedCompanyNames);
    setSelectedAffectedCompanies(nextValue);
  };
  useEffect(() => {
    try {

      if (radioVal1 === "tracknow") {

        const filtAffectedComp = affectedCompanyLists.filter(
          (id) => id.trackNowLicenseId
        );
        setAffectedCompanyListsDropdown(filtAffectedComp);
      } else {
        console.log(
          "radioVal1",
          radioVal1,
          "affectedCompanies",
          affectedCompanyLists
        );
        const filtAffectedComp = affectedCompanyLists.filter(
          (id) => id.postAwardLicenseId
        );
        setAffectedCompanyListsDropdown(filtAffectedComp);
      }
    } catch (error) {
      console.log("error", error);

    }
  }, [radioVal1, affectedCompanyLists]);
  console.log("affectedCompaniesDropDown", affectedCompanyListsDropdown);
  const handleChildCompanyChangeEdit = (e) => {
    // Current selected values from MultiSelect
    const nextValue = normalizeSelectedIds(e.value);

    // Initial values (convert all to string)
    const initialIds = normalizeSelectedIds(selectedAffectedCompaniesEditInitial);

    // Find newly selected IDs
    const newIds = nextValue.filter(
      (id) => !initialIds.includes(String(id))
    );

    // Final selected IDs (remove duplicates)
    const finalIds = [...new Set([...initialIds, ...newIds])];

    // Get company names
    const finalNames = finalIds
      .map((id) => {
        const company = affectedCompanyLists.find(
          (c) => String(c.customerId) === String(id)
        );

        return company
          ? {
            customerId: String(company.customerId),
            customerName: company.customerName,
          }
          : null;
      })
      .filter(Boolean);

    setCustomerNames(finalNames);
    setSelectedAffectedCompaniesEdit(finalIds);
  };
  console.log(
    "check customerNames",
    customerNames,
    "selectedAffectedCompaniesEdit",
    selectedAffectedCompaniesEdit
  );
  let trackerTable = useRef();
  console.log("comments", comments, selectedFiling[0]);
  console.log("clientFilingData", clientFilingData);

  console.log("###CHECL CUST tracker selectedCustomer", selectedCustomer, "selectedClientId", selectedClientId);
  useEffect(() => {
    console.log("CLEAR SELECTED RECORDS", "LIST", clearSelectedRecords);
    if (clearSelectedRecords) {
      setKeepSelectedRecords([])
      setSelectedFiling([])
    }
  }, [clearSelectedRecords])

  return (
    <Fragment>
      <ClientFilingBulkStatusUpdate
        show={showBulkStatusDrawer}
        dockAt="right"
        statusRecords={selectedFiling}
        childList={bulkUpdateRecords}
        commonStaffs={commonStaffs}
        setClearSelectedRecords={setClearSelectedRecords}
        handleClose={closeStatusBulkUpdateDrawer}
        handleRefreshTable={refreshSelectedRecord}
        selectedClientId={selectedClientId}
        isDetailedView={detailedViewVal}
        selectedCustomer={selectedCustomer}
      // updateSelectedWorkflow={updateSelectedWorkflow}
      />
      <CustomDialog header="Info" visible={showAlert} onHide={() => closeAlert()} footer={null}>
        {alertMessage}
      </CustomDialog>
      <CustomDialog
        header="Confirmation"
        visible={showRadio}
        onHide={() => radioCloseAlert()}
        footer={radioFooterContent}
      >
        <p className="m-0">{radioMessage}</p>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={radioVal}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="tracknow"
              control={<Radio />}
              label="Track Now"
            />
            <FormControlLabel
              value="postaward"
              control={<Radio />}
              label="Post Award"
            />
          </RadioGroup>
        </FormControl>
      </CustomDialog>
      <CustomDialog
        header={<span style={{ color: tokens.colors.success }}>Confirmation</span>}
        visible={showRadio1}
        onHide={() => radioCloseAlert1()}
        footer={radioFooterContent1}
        icon={<NoticeIllustration />}
        compact
        autoZIndex={false}
        baseZIndex={2400}
        style={{ width: "560px", maxWidth: "90vw" }}
        contentStyle={{ overflow: "visible" }}
      >
        <p className="m-0">{isTrackNowAccess && isPostAwardAccess ? radioMessage1 : ""}</p>

        <FormControl>
          <Stack direction="column" spacing={2}>
            {isTrackNowAccess && isPostAwardAccess && (
              <div className="company-dialog-recordtype-options">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={radioVal1}
                  onChange={handleRadioChange1}
                >
                  <FormControlLabel
                    disabled={
                      !(selectedCustomer?.trackNowLicenseId && selectedCustomer.trackNowLicenseId > 0) ||
                      !(selectedCustomer?.postAwardLicenseId && selectedCustomer.postAwardLicenseId > 0)
                    }
                    value="tracknow"
                    control={<Radio />}
                    label="Track Now"
                  />
                  <FormControlLabel
                    disabled={
                      !(selectedCustomer?.postAwardLicenseId && selectedCustomer.postAwardLicenseId > 0) ||
                      !(selectedCustomer?.trackNowLicenseId && selectedCustomer.trackNowLicenseId > 0)
                    }
                    value="postaward"
                    control={<Radio />}
                    label="Post Award"
                  />
                </RadioGroup>
              </div>
            )}
            {((selectedCustomer?.clientType === "Parent" && !selectedCustomer?.isOnlyChildFile) || (selectedCustomer?.clientType === "Child" && selectedCustomer?.bothChildAndSubChild)) &&
              (
                <div>
                  <FormLabel className={`company-dialog-company-label ${isCompanySelectOpen ? "company-dialog-company-label--active" : ""}`}>
                    <Typography>
                      Please Select Parent/Child/Sub Child Company (s)
                    </Typography>
                  </FormLabel>

                  <MultiSelect
                    value={normalizeSelectedIds(selectedAffectedCompanies).map((id) => String(id))}
                    options={companySelectOptions}
                    onChange={(e) =>
                      handleChildCompanyChange({ value: e.value }, affectedCompanyListsDropdown)
                    }
                    optionLabel="label"
                    optionValue="value"
                    optionDisabled="disabled"
                    placeholder="Select Company"
                    //selectedItemTemplate={(value) => renderCompanySelectedItem(value, selectedAffectedCompanies)}
                    panelHeaderTemplate={renderCompanyPanelHeader}
                    appendTo="self"
                    autoZIndex={false}
                    baseZIndex={2450}
                    className="company-dialog-multiselect"
                    panelClassName="company-dialog-multiselect-panel"
                    onShow={() => setIsCompanySelectOpen(true)}
                    onHide={() => setIsCompanySelectOpen(false)}
                    style={{ width: "100%" }}
                  />
                </div>
              )}
          </Stack>
        </FormControl>
      </CustomDialog>
      <CustomDialog
        header={<span style={{ color: tokens.colors.success }}>Confirmation</span>}
        visible={showRadioEdit}
        onHide={() => radioCloseAlertEdit()}
        footer={radioFooterContentEdit}
        icon={<NoticeIllustration />}
        compact
        autoZIndex={false}
        baseZIndex={2400}
        contentStyle={{ overflow: "visible" }}
      >
        {/* <p className='m-0'>{radioMessage1}</p> */}
        {(selectedCustomer?.clientType === "Parent" ||
          selectedCustomer?.clientType === "Child") && (
            <FormControl>
              <Stack direction="column" spacing={2}>
                <FormLabel className={`company-dialog-company-label ${isCompanySelectEditOpen ? "company-dialog-company-label--active" : ""}`}>
                  <Typography>
                    {selectedCustomer?.clientType === "Parent" ? (
                      <span>
                        If you want to add the filing to the Child company as well,
                        please select child Company(s)
                      </span>
                    ) :
                      <span>
                        If you want to add the filing to the Sub Child company as well,
                        please select sub child Company(s)
                      </span>
                    }
                  </Typography>
                </FormLabel>

                <MultiSelect
                  value={normalizeSelectedIds(selectedAffectedCompaniesEdit).map((id) => String(id))}
                  options={companySelectOptions}
                  onChange={(e) => handleChildCompanyChangeEdit({ value: e.value }, "edit")}
                  optionLabel="label"
                  optionValue="value"
                  optionDisabled="disabled"
                  placeholder="Select Company"
                  // selectedItemTemplate={(value) => renderCompanySelectedItem(value, selectedAffectedCompaniesEdit)}
                  panelHeaderTemplate={renderCompanyPanelHeader}
                  appendTo="self"
                  autoZIndex={false}
                  baseZIndex={2450}
                  className="company-dialog-multiselect"
                  panelClassName="company-dialog-multiselect-panel"
                  onShow={() => setIsCompanySelectEditOpen(true)}
                  onHide={() => setIsCompanySelectEditOpen(false)}
                  style={{ width: "100%" }}
                />
              </Stack>
            </FormControl>
          )}
      </CustomDialog>

      <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
        <Grid style={{ height: "100%", width: "93%" }}>
          <Grid sm={24}>
            <div style={{ width: "89vw", margin: "0 0rem" }}>
              <ClientLookup
                setSelectedClientId={setSelectedClientId}
                parentRoute="client-filing-tracker-list"
                showStructure={displayOrganizationalStructure}

              />
            </div>
          </Grid>
          <Grid sm={24}>
            <div
              className="card"
              style={{
                width: "89vw",
                padding: "0.1rem",
                margin: "0 1rem",
                background: tokens.colors.offWhite,
                borderRadius: "8px",
                overflow: "visible",
                border: "none",
              }}
            >
              <ClientFilingTrackerTable
                ref={trackerTable}
                selectedClientId={selectedClientId}
                setSelectedFiling={setSelectedFiling}
                setDetailedViewVal={setDetailedViewVal}
                setSortRecord={setSortRecord}
                setTablValue={setTablValue}
                setSelectedYear={setSelectedYear}
                setClientFilingData={setClientFilingData}
                refreshList={refreshList}
                setStaffList={setStaffList}
                resetRefreshList={resetRefreshList}
                refreshAttachments={refreshAttachments}
                displayAttachments={displayAttachments}
                displayDocuments={displayDocuments}
                displayComments={addComment}
                setUnderDetailedViewProps={setUnderDetailedViewProps}
                // downloadData={setDownloadData}
                // downloadDataHistory={setDownloadDataHistory}
                handleRefreshTableReturn={handleRefreshTableReturn}
                refreshTable={refreshTable}
                keepSelectedRecords={keepSelectedRecords}
                resetKeepSelectedRecords={(e) => setKeepSelectedRecords(e)}
                keepPageDetails={keepPageDetails}
                resetKeepPageDetails={(e) => setKeepPageDetails(e)}
                handleRefreshTable={handleRefreshTable}
                clearSelectedRecords={clearSelectedRecords}
                setClearSelectedRecords={setClearSelectedRecords}
              />
            </div>
          </Grid>
        </Grid>

        <Grid
          sx={{
            height: "100%",
            width: "5%",
            position: "sticky",
            top: 10,
            alignSelf: "flex-start",
          }}
        >
          <div
            style={{
              height: "100%",
              background: "transparent",
              marginTop: "0",
            }}
          >
            <Item
              sx={{
                height: "100%",
                background: "transparent",
                boxShadow: "none",
                borderRadius: "50px",
                overflow: "visible"
              }}
            >
              <Toolbox
                displayFilter={displayFilter}
                displayClientFiling={displayClientFiling}
                displayCalendarView={displayCalendarView}
                displayAddClientFiling={displayAddClientFiling}
                displayComments={addComment}
                displayAttachments={displayAttachments}
                displayHistory={displayHistory}
                updateBulkStatus={updateBulkStatus}
                displayDocuments={displayDocuments}
                displayConsolidatedView={displayConsolidatedView}
                // displayClientSpecificConsolidatedView={displayClientSpecificConsolidatedView}
                downloadData={exportExcel}
                downloadDataHistory={exportExcelHistory}
                editMasterFilling={editMasterFilling}
                addMasterFilling={addMasterFilling}
                // deleteMasterRecord={handleDelete}
                deleteClientFiling={handleDelete}
                deleteRecord={handleDeleteRecord}
                hasTrackNowAccess={isTrackNowAccess}
                hasPostAwaradAccess={isPostAwardAccess}
                isTabValue={tablValue === "2" ? true : false}
                isMasterFiling={
                  selectedFiling ? selectedFiling[0]?.isMasterFiling : true
                }
                selectedClientId={selectedClientId}
                downloadProgress={downloadProgress}
                downloadStatusMsg={downloadStatusMsg}
                isDownloading={showDownloadProgress}
              />
            </Item>
          </div>
        </Grid>
      </div>
      <ConfirmDialog />
      {
        <ClientFilingTrackerComments
          show={showComments}
          dockAt="right"
          tracker={selectedFiling[0]}
          comments={comments}
          isDetailedView={detailedViewVal}
          handleClose={closeComments}
          refreshList={refreshList}
          resetRefreshList={resetRefreshList}
          handleRefreshTable={refreshSelectedRecord}
        />
      }
      {
        <ClientFilingTrackerAttachment
          show={showAttachments}
          dockAt="right"
          tracker={selectedFiling[0]}
          attachments={attachments}
          isDetailedView={detailedViewVal}
          handleClose={closeAttachments}
          refreshAttachments={refreshAttachments}
          handleRefreshTable={handleRefreshTable}
        />
      }
      {
        <CustomerOrgStructure
          show={showOrgStructure}
          dockAt='right'
          cust={selectedCustomer}
          selectedClientId={selectedClientId}
          orgStructure={organizationalStructure}
          handleClose={closeOrgStucture}
          onCustomerClick={(customer) => {
            setSelectedClientId(customer.customerId);
            setCurrentCustomer(customer);
            setShowOrgStructure(false);

            navigate(`/client-filing-tracker-list/${customer.customerId}`, {
              state: {
                clientName: customer.customerName,
              },
            });
          }}
        //refreshTable={tableRefresh}
        //displayClientFiling={displayClientFiling}
        />
      }
      {
        <ClientFilingTrackerHistory
          show={showHistory}
          dockAt="right"
          tracker={selectedFiling[0]}
          activityHistory={activityHistory}
          isCommentsTabLoading={isCommentsHistoryLoading}
          isTrackNowTabLoading={isTnistoryLoading}
          isClientFilingTabLoading={isCfHistoryLoading}
          clientActivityHistory={clientActivityHistory}
          commentActivityHistory={commentActivityHistory}
          handleClose={closeHistory}
          setActivityHistory={setActivityHistory}
          setClientActivityHistory={setClientActivityHistory}
          setCommentActivityHistory={setCommentActivityHistory}
          setIsCfHistoryLoading={setIsCfHistoryLoading}
          setIsCommentsHistoryLoading={setIsCommentsHistoryLoading}
          setIsTnHistoryLoading={setIsTnHistoryLoading}
        />
      }
      {
        <ClientFilingTrackerDocuments
          show={showDocuments}
          dockAt="right"
          tracker={selectedFiling[0]}
          attachments={documents}
          handleClose={closeDocuments}
        />
      }
      {
        <ClientFilingConsolidatedUpdate
          show={showConsolidated}
          dockAt="right"
          cust={selectedFiling[0]}
          consolidatedRecords={consolidatedRecords}
          consolidatedStatus={consolidatedStatus}
          staffList={staffList}
          handleClose={closeConsolidated}
          selectedClientId={selectedClientId}
          handleRefreshTable={refreshSelectedRecord}
          refreshConsList={() => fetchConsolidatedRecords(selectedFiling[0])}
          setClearSelectedRecords={setClearSelectedRecords}
        />
      }
    </Fragment >
  );
}

export default ClientFilingTrackerList;




